import { render, staticRenderFns } from "./VehicleAssignments.vue?vue&type=template&id=3e58e594&scoped=true"
import script from "./VehicleAssignments.vue?vue&type=script&lang=js"
export * from "./VehicleAssignments.vue?vue&type=script&lang=js"
import style0 from "./VehicleAssignments.vue?vue&type=style&index=0&id=3e58e594&prod&scoped=true&lang=css"
import style1 from "./VehicleAssignments.vue?vue&type=style&index=1&id=3e58e594&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e58e594",
  null
  
)

export default component.exports